module.exports = __webpack_public_path__ + "static/media/Avatar-Transition.6d288f53.gif";